import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./Aboutus.css";
import Banner from "./Banner";
import Whychoose from "../Home/Why Choose/Whychoose";
import Values from "../Home/Values/Values";
import Missio from "./Mission Vision/Missio";
import Team from "../Home/Teams/Team";
import About from "../Home/About/About";
import Review from "../Home/Teams/Reviews/Review"
import Contact_banner from "../Contact us/Contact_banner";
const AboutUs = () => {
    return (
        <>
            {/* <Banner /> */}
            <Contact_banner />
            <About />
            <Missio />
            <Team />
            <Whychoose />
            <Values />
            <Review />

        </>
    );
};

export default AboutUs;
